const ConfidentialOption = [
    { value: 0, label: 'Non-Confidential' },
    { value: 1, label: 'Confidential' },
  ]

export default ConfidentialOption